import React from "react";
import { AppearanceContextType, useAppearanceContext } from "@contexts/AppearanceContext";
import LifeAtButton from "../LifeAtButton";
import "./CloseButton.scss";
import CloseIcon from "/resources/icons/CloseIcon.svg";

interface CloseButtonProps {
    handleClose: () => void;
    className?: string;
}
export default function CloseButton(props: CloseButtonProps) {
    const { lightMode }: AppearanceContextType = useAppearanceContext();

    return (
        <span className={`close-button ${props.className}`}>
            <LifeAtButton
                isLink={false}
                icon={<CloseIcon className={`close-icon ${lightMode ? "light" : "dark"}`} />}
                handleClick={props.handleClose}
            />
        </span>
    );
}
